import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateRecordResponsiblePerson(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $employeeId: ID!
    $input: SpaceResponsiblePersonInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateResponsiblePerson(
                  spaceRecordId: $spaceRecordId
                  employeeId: $employeeId
                  input: $input
                )
              }
            }
          }
        }
      }
    }
  }
`
export const executor = graphql.createExecutor<
  graphql.schema.UpdateRecordResponsiblePersonMutation,
  undefined,
  graphql.schema.UpdateRecordResponsiblePersonMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
